import { Whisper, Button } from 'rsuite';
import { useRef } from 'react';
import { icons } from '@shared/static/icons';
import {
  TeamTableMobileMenu,
  EditTeamMenu,
  BalancesTableMobileMenu,
} from '@widgets/teams/menu';
import ReferralsMobileMenu from '@widgets/referrals/ReferralsMobileMenu';

export default function TableMenuBtn({ data, menu }) {
  const ref = useRef();

  function close() {
    ref.current.close();
  }

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  const MENU_COMPONENTS = {
    teams: TeamTableMobileMenu,
    teamId: EditTeamMenu,
    balances: BalancesTableMobileMenu,
    referrals: ReferralsMobileMenu,
    // TODO: обновить меню транзакций, сейчас это копия меню баланса
    transactions: BalancesTableMobileMenu,
  };

  const MenuComponent = MENU_COMPONENTS[menu] ?? null;

  return (
    <Whisper
      placement="auto"
      controlId="control-id-with-dropdown"
      trigger="click"
      ref={ref}
      speaker={<MenuComponent close={close} data={data} group={data} />}
    >
      <Button
        appearance="secondary"
        className="theme-btn theme-btn--icon"
        onClick={handleClick}
      >
        {icons['more']}
      </Button>
    </Whisper>
  );
}
